import { ISourcingToolSearchFilter } from "react-migration/domains/search/typings/SourcingToolSpecificFilterTypes";
import { SearchType } from "react-migration/domains/search/constants/searchTypes";
import { ConstrainedListFilterMust } from "react-migration/domains/search/typings/SourcingToolFilters/types";
import Feature from "src/js/stores/user/Feature";

export const AdoptedRoadsType: ISourcingToolSearchFilter = {
  id: "adopted-roads-type-id",
  type: "checkbox",
  must: ConstrainedListFilterMust.MATCH_ALL,
  mustOptions: [ConstrainedListFilterMust.MATCH_ALL],
  updateFilterDialogIsVisible: false,
  hideFilter: true,
  values: [
    {
      key: "adopted",
      name: "Maintainable at public expense",
    },
    {
      key: "prospective",
      name: "Provisionally maintainable at public expense",
    },
  ],
};

export const AdoptedRoadsDistance: ISourcingToolSearchFilter = {
  id: "adopted-roads-distance-id",
  field: "sidebar.react.search_sidebar.adopted_roads.number",
  type: "number",
  displayMessages: {
    mustOption: "seems.pointless.empty_string",
  },
  rangeLimit: [0, null],
  distanceGranularity: "small",
};

export const AdoptedRoadsFilter: ISourcingToolSearchFilter = {
  id: "adopted-roads-id",
  field: "sidebar.react.search_sidebar.adopted_roads",
  type: "compound",
  must: "MATCH_ANY",
  mustOptions: ["MATCH_ANY"],
  filters: [AdoptedRoadsType, AdoptedRoadsDistance],
  requiredFilters: "all",
  searchTypes: [SearchType.SOURCING_TOOL_UK],
  displayMessages: {
    updateTitle: "sidebar.react.search_sidebar.adopted_roads.title",
  },
};
